import React, { useState, useEffect } from 'react';
import { PlanoVinculadoEntidade, FichaFinanceiraEntidade, DependenteEntidade, SaldoContribuicoesFaelceEntidade } from '@entidades';
import { DependenteService, FichaFinanceiraService, PlanoService } from '@services';
import { Alert, Button, Row, Col } from '@intech/web-ui';

import { Header } from './Header';
import { UltimaContribuicaoDetalhe } from './UltimaContribuicaoDetalhe';
import { SaldoAcumulado } from './SaldoAcumulado';
import { useHistory } from 'react-router-dom';
import { buscarBloqueio, NumFuncionalidade } from "./../../../helpers/BloqueioFuncionalidade";
import { Beneficiarios } from '@components';

interface IProps {
  plano: PlanoVinculadoEntidade;
}

export const Ativo: React.FC<IProps> = ({
  plano
}) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [SRC, setSRC] = useState<number>(0);
  const [Referencia, setReferencia] = useState<string>("");
  const [TempoPlano, setTempoPlano] = useState<string>("");
  const [UltimaContribuicao, setUltimaContribuicao] = useState<Array<FichaFinanceiraEntidade>>(new Array<FichaFinanceiraEntidade>());
  const [Saldo, setSaldo] = useState<SaldoContribuicoesFaelceEntidade>();
  const [MotivoBloqueio, setMotivoBloqueio] = useState<string>("");

  useEffect(() => {
    (async () => {
      setMotivoBloqueio(await buscarBloqueio(NumFuncionalidade.HOME_ATIVOS_E_AUTOPATROCINADOS));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const tempoPlano = await PlanoService.BuscarTempoPlano(plano.CD_PLANO);
        setTempoPlano(tempoPlano);

        const ultimaContribuicao = await FichaFinanceiraService.BuscarContribuicao(plano.CD_PLANO);
        console.log(ultimaContribuicao);
        setUltimaContribuicao(ultimaContribuicao);

        if (plano.CD_PLANO === "0001") {
          setSRC(ultimaContribuicao[0].SRC!);
          setReferencia(ultimaContribuicao[0].MES_COMP + "/" + ultimaContribuicao[0].ANO_COMP);
        }

        if (plano.CD_PLANO === "0002") {
          const src_info = await FichaFinanceiraService.BuscarSRCCD(plano.CD_PLANO);
          if (src_info.length > 0) {
            setSRC(src_info[0].SRC!);
            setReferencia(src_info[0].MES_COMP + "/" + src_info[0].ANO_COMP);

            const saldo = await FichaFinanceiraService.BuscarSaldoContribuicoes(plano.CD_PLANO);
            setSaldo(saldo);
          }
        }

      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, [plano]);

  if (MotivoBloqueio !== "") {
    return (
      <Alert type={"danger"}>
        {MotivoBloqueio}
      </Alert>
    );
  }

  return (
    <>
      {AlertText !== "" && <Alert type={"danger"}>
        {AlertText}
      </Alert>}

      <Header
        plano={plano}
        tempoPlano={TempoPlano}
        SRC={SRC}
        referencia={Referencia}
      />

      <Row>
        <Col>
          <Beneficiarios />
        </Col>
      </Row>

      <Row>
        <Col>
          <UltimaContribuicaoDetalhe ultimaContribuicao={UltimaContribuicao} referencia={Referencia} />
        </Col>

        <Col>
          <SaldoAcumulado saldoAcumulado={Saldo} />
        </Col>
      </Row>

      <Button
        onClick={() => history.push("/extrato")}
        title={"Ir Para Extrato de Contribuições"}
        type={"primary"}
        block
      />

      {plano.CD_PLANO === "0002" && plano.CD_CATEGORIA !== "2" &&
        <Button
          onClick={() => history.push("/simuladorAposentadoria")}
          title={"Ir Para Simulador de Benefícios"}
          type={"primary"}
          block
        />
      }
    </>
  );
}